import * as React from 'react'
import { useEffect } from 'react'

import { useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import { Ids } from '../../../constants/Ids'
import URI from '../../../misc/classes/URI'
import scrollToHash from '../../../misc/helpers/scrollToHash'
import background from '../../../misc/images/backgrounds/background_10.jpg'
import { ITenantResponse } from '../../../models/Tenant'
import routes from '../../../router/routes'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { ImageSection } from '../../_layout/ImageSection'
import PageWrapper from '../../_layout/PageWrapper'
import Breadcrumbs from '../../reusable/Breadcrumbs'
import { Loading } from '../../reusable/Loading'
import { Tenant } from '../../templates/Tenant'

const TenantScreen = () => {
  const i18n = useRecoilValue(translate).tenant
  const breadcrumbs = [
    {
      link: routes.tenant,
      title: i18n.breadcrumb,
    },
  ]
  const lang = useRecoilValue(locale)
  const location = useLocation()
  const { data, isValidating } = useSWR<ITenantResponse>(URI.getTenantUri(lang))

  useEffect(() => {
    scrollToHash(Boolean(data), location.hash, 500)
  }, [lang, data, location.hash])

  return (
    <React.Suspense fallback={<Loading />}>
      <ImageSection id={Ids.tenant} image={background} />
      <PageWrapper>
        <Breadcrumbs base={breadcrumbs} />
        {isValidating && <Loading />}
        {!!data?.data && <Tenant data={data.data} />}
      </PageWrapper>
    </React.Suspense>
  )
}

export default TenantScreen
